import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcBadHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 11,
			fill: "#415E96"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.91565 16.778C9.9145 16.7797 9.91333 16.7814 9.91216 16.7831C9.91242 16.7828 9.91276 16.7823 9.91321 16.7817C9.91607 16.7779 9.92288 16.7689 9.93397 16.7556C9.95614 16.729 9.9955 16.6848 10.0549 16.6286C10.1733 16.5164 10.3728 16.3548 10.677 16.1889C11.2827 15.8585 12.3237 15.5 14.0001 15.5C15.6764 15.5 16.7174 15.8585 17.3231 16.1889C17.6273 16.3548 17.8268 16.5164 17.9452 16.6286C18.0046 16.6848 18.044 16.729 18.0661 16.7556C18.0772 16.7689 18.084 16.7779 18.0869 16.7817C18.0873 16.7823 18.0877 16.7828 18.088 16.7831C18.2425 17.0082 18.5496 17.0679 18.7774 16.916C19.0072 16.7628 19.0693 16.4524 18.9161 16.2226L18.5001 16.5C18.9161 16.2226 18.9159 16.2223 18.9156 16.222L18.9152 16.2213L18.9141 16.2197L18.9118 16.2163L18.9059 16.2078C18.9014 16.2014 18.8958 16.1936 18.889 16.1846C18.8755 16.1665 18.8574 16.1432 18.8344 16.1155C18.7882 16.06 18.7221 15.987 18.633 15.9026C18.4546 15.7336 18.1853 15.5202 17.802 15.3111C17.0327 14.8915 15.8237 14.5 14.0001 14.5C12.1764 14.5 10.9674 14.8915 10.1981 15.3111C9.81477 15.5202 9.54554 15.7336 9.36712 15.9026C9.27804 15.987 9.21193 16.06 9.16575 16.1155C9.14266 16.1432 9.12456 16.1665 9.11107 16.1846C9.10433 16.1936 9.09873 16.2014 9.09424 16.2078L9.08833 16.2163L9.08598 16.2197L9.08495 16.2213L9.08448 16.222C9.08425 16.2223 9.08403 16.2226 9.50005 16.5L9.08403 16.2226C8.93085 16.4524 8.99294 16.7628 9.2227 16.916C9.45052 17.0679 9.75766 17.0081 9.91216 16.7831C9.91158 16.7839 9.91148 16.7841 9.91182 16.7836L9.91326 16.7815L9.9145 16.7797L9.91525 16.7786L9.91565 16.778ZM18.0849 16.7787L18.0856 16.7797L18.0868 16.7815L18.0883 16.7836C18.0886 16.7841 18.0885 16.7839 18.088 16.7831",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 12,
			r: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 12,
			r: 1,
			fill: "white"
		})
	]
});
export default SvgIcBadHome;
